import homepage from './homepage'
import resultsQuery from './resultsquery'
const studentResults = {
  path: 'studentResults',
  component: resolve => require(['../../../components/pages/studentresults'], resolve),
  redirect: 'studentResults/homepage',
  children: [
    ...resultsQuery,
    homepage
  ]
}
export default studentResults



// WEBPACK FOOTER //
// ./src/router/pages/studentresults/index.js